import {useEffect, useState} from 'react';
import {UncoveredSpendApi, uncoveredFromResponse} from '../../api/uncoveredSpendApi';

// Los criterios de «CÓMO SE ELIGEN» del panel (`panel.lines[i].campaigns.selection[].mode`).
const MODES_THAT_LEAVE_OUT = ['LIST', 'CONDITION'];
const LEVELS_WITHOUT_CAMPAIGNS = ['ANALYTICS', 'ECOMMERCE'];

/**
 * ¿La regla de alguna cuenta de la línea puede dejar campañas afuera? Sólo una lista o una condición
 * sobre una cuenta de pauta: con «toda la cuenta» no hay nada afuera, y GA4 y las tiendas entran enteras.
 * Así el panel no pide el detalle de las líneas que no pueden tenerlo, que son la mayoría.
 */
export function lineMayLeaveSpendOut(line) {
    const selection = ((line && line.campaigns) || {}).selection || [];
    return selection.some((entry) => MODES_THAT_LEAVE_OUT.includes(entry.mode)
        && !LEVELS_WITHOUT_CAMPAIGNS.includes(entry.level));
}

/**
 * Lo que la línea deja afuera, para la fila del panel del cliente. Si el payload del panel trae
 * `uncovered_spend` (el backend de la tanda «Inversión sin línea» lo manda en cada línea, aunque sea `null`),
 * se usa ese y no se pide nada; con un backend viejo, sin la clave, se pide el endpoint de detalle.
 *
 * Es un dato que acompaña a la fila, no la gatea: si el pedido falla, la fila queda como siempre y no se
 * avisa nada (mismo criterio que los refrescos de fondo del Tablero). El 5xx lo reporta `APIClient`.
 */
export function useLineUncoveredSpend(line) {
    const inline = line && Object.prototype.hasOwnProperty.call(line, 'uncovered_spend') ? line.uncovered_spend : undefined;
    const lineId = line ? line.id : null;
    const shouldFetch = inline === undefined && !!lineId && lineMayLeaveSpendOut(line);
    const [fetched, setFetched] = useState(null);

    useEffect(() => {
        if (!shouldFetch) return undefined;
        let alive = true;
        UncoveredSpendApi.forLine(lineId)
            .then((response) => {
                if (alive) setFetched(uncoveredFromResponse(response));
            })
            .catch(() => {});
        return () => { alive = false; };
    }, [shouldFetch, lineId]);

    return inline !== undefined ? inline : (shouldFetch ? fetched : null);
}
